<div>
    <h2 mat-dialog-title class="cut-long-text">
        @if (!data.hasId()) {
            Neuer Datensatz
        } @else {
            Datensatz bearbeiten
        }
    </h2>
    <mat-divider></mat-divider>

    <form [formGroup]="formGroup" class="learning-section-form">
        <mat-dialog-content class="grid">

            <mat-form-field>
                <mat-label>Name</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="name"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["name"])
                }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Titel</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="title"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["title"])
                }}</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Typ</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    placeholder=""
                    formControlName="learningSectionType"
                />
                <mat-error>{{
                    checkForErrors(formGroup.controls["title"])
                }}</mat-error>
            </mat-form-field>

            @if (layouts$ | async; as lo) {
                <mat-form-field>
                    <mat-label>Layout</mat-label>
                    <mat-select formControlName="learningSectionLayout">
                        @for (layout of lo; track layout) {
                            <mat-option [value]="layout">{{
                                layout.name
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            }

            <div class="full-width" style="padding-bottom:20px;">
                <mat-slide-toggle
                        formControlName="showCopyright"
                        labelPosition="after"
                        class="slide-toggler"
                >
                    Copyright-Hinweise für Bilder aktivieren
                </mat-slide-toggle>
            </div>

            <mat-form-field class="full-width">
                <mat-label>Konsument</mat-label>
                <mat-select formControlName="consumer">
                    @for (consumer of consumers; track consumer) {
                        <mat-option [value]="consumer">{{
                            consumer.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width">
                <mat-label>Fächer/Berufe</mat-label>
                <mat-select formControlName="subjects" multiple>
                    @for (subject of subjects; track subject) {
                        <mat-option [value]="subject">{{
                            subject.name
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-dialog-content>
    </form>
    <mat-divider></mat-divider>

    <mat-dialog-actions>
        <button mat-raised-button (click)="onCancel()">Abbruch</button>
        <button
            mat-raised-button
            (click)="onSave()"
            [disabled]="
                !formGroup.valid || formGroup.controls['name'].value === ''
            "
        >
            Speichern
        </button>
    </mat-dialog-actions>
</div>
